import { render, staticRenderFns } from "./CatalogMiniatureWithInformation.vue?vue&type=template&id=191bae0c"
import script from "./CatalogMiniatureWithInformation.vue?vue&type=script&lang=ts"
export * from "./CatalogMiniatureWithInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports